/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendProductVariantDto } from '../../models/backend-product-variant-dto';
import { BackendProductVariantRequestDto } from '../../models/backend-product-variant-request-dto';

export interface SalesProductVariantsCreate$Params {
  body: BackendProductVariantRequestDto;
}

export function salesProductVariantsCreate(
  http: HttpClient,
  rootUrl: string,
  params: SalesProductVariantsCreate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendProductVariantDto>> {
  const rb = new RequestBuilder(rootUrl, salesProductVariantsCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendProductVariantDto>;
    }),
  );
}

salesProductVariantsCreate.PATH = '/api/sales/product_variants/';
